// Generated by OrchestKit Claude Plugin
// Created: 2026-09-15

/**
 * Mode sombre — trois réglages, un seul appliqué à la fois.
 *
 * « Système » n'est pas une valeur stockée : c'est l'ABSENCE d'attribut
 * `data-theme`, qui laisse `prefers-color-scheme` décider (voir
 * `theme/tokens.css`). Un choix explicite pose l'attribut et gagne dans les
 * deux sens, y compris contre un système qui changerait en cours de session.
 */
export type Theme = 'systeme' | 'clair' | 'sombre';

const CLE_STOCKAGE = 'gv-theme';

const SUIVANT: Record<Theme, Theme> = {
  systeme: 'clair',
  clair: 'sombre',
  sombre: 'systeme',
};

export const LIBELLE_THEME: Record<Theme, string> = {
  systeme: 'Système',
  clair: 'Clair',
  sombre: 'Sombre',
};

/** Réglage mémorisé, ou « système » si rien n'a jamais été choisi. */
export function themeMemorise(): Theme {
  const valeur = localStorage.getItem(CLE_STOCKAGE);
  return valeur === 'clair' || valeur === 'sombre' ? valeur : 'systeme';
}

/**
 * Applique un thème au document.
 *
 * Pose ou retire `data-theme` sur `<html>`, PAS sur un conteneur interne :
 * les jetons sont déclarés sur `:root`, qui suit l'attribut de la racine du
 * document. Un attribut posé plus bas ne changerait rien.
 */
export function appliquerTheme(theme: Theme): void {
  if (theme === 'systeme') {
    document.documentElement.removeAttribute('data-theme');
    localStorage.removeItem(CLE_STOCKAGE);
  } else {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(CLE_STOCKAGE, theme);
  }
}

/** Le réglage qui suit celui-ci dans le cycle du bouton — voir `BoutonTheme`. */
export function themeSuivant(theme: Theme): Theme {
  return SUIVANT[theme];
}
